"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _element = require("@wordpress/element");

var _i18n = require("@wordpress/i18n");

var _components = require("@wordpress/components");

var _icons = require("@wordpress/icons");

/**
 * WordPress dependencies
 */
function BlockFullHeightAlignmentToolbar(_ref) {
  var isActive = _ref.isActive,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? (0, _i18n.__)('Toggle full height') : _ref$label,
      onToggle = _ref.onToggle;
  return (0, _element.createElement)(_components.ToolbarGroup, null, (0, _element.createElement)(_components.ToolbarButton, {
    isActive: isActive,
    icon: _icons.fullscreen,
    label: label,
    onClick: function onClick() {
      return onToggle(!isActive);
    }
  }));
}

var _default = BlockFullHeightAlignmentToolbar;
exports.default = _default;
//# sourceMappingURL=index.js.map